import axiosInstance from '@/shared/api/axios';
import type {
  ApiPricingConfigResponse,
  ApiPricingConfigPutBody,
} from '@/shared/types/api/pricing';

export const apiPricingConfigGet = async (): Promise<ApiPricingConfigResponse> => {
  const { data } = await axiosInstance.get<ApiPricingConfigResponse>('/pricing/config');
  return data;
};

export const apiPricingConfigPut = async (
  body: ApiPricingConfigPutBody,
): Promise<ApiPricingConfigResponse> => {
  const { data } = await axiosInstance.put<ApiPricingConfigResponse>('/pricing/config', body);
  return data;
};
